module.exports = __webpack_public_path__ + "img/inst-pres-bg-mob.e2c572c4.svg";